// https://github.com/Hopding/pdf-lib#documentation
require("babel-polyfill");

import { PDFDocument } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import download from 'downloadjs';

/** Data
 * 
 company
 street
 zip location
 country
 name

  Webhosting
  Webhosting_EMail
  Microsoft365
  Webdesign
  Werbung
  Kundenbetreuung
 */


 

export default async function flattenForm(formData) {
  // Load the PDF with form fields
  const formUrl = '/assets/AV Vertrag_leer.pdf'
  const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(formPdfBytes)

  const form = pdfDoc.getForm()

  // get Fonts
  pdfDoc.registerFontkit(fontkit)
  const urlFontMedium = '/assets/fonts/subset-UnitedSansReg-Medium.ttf'
  const urlFontBold = '/assets/fonts/subset-UnitedSansReg-Bold.ttf'
  const fontBytesMedium = await fetch(urlFontMedium).then((res) => res.arrayBuffer())
  const fontBytesBold = await fetch(urlFontBold).then((res) => res.arrayBuffer())
  
  const fontMedium = await pdfDoc.embedFont(fontBytesMedium)
  const fontBold = await pdfDoc.embedFont(fontBytesBold)
  
  
  // Fill the form's fields
  form.getTextField('Firma').setText(formData.company);
  // form.getTextField('Name').setText(formData.name);
  form.getTextField('Strasse').setText(formData.street);
  form.getTextField('Ort').setText( `${formData.zip} ${formData.location}`);
  
  formData.Webhosting === 'on' ? 
    form.getCheckBox('Webhosting').check() : '' ;
  formData.Webhosting_EMail === 'on' ? 
    form.getCheckBox('EMail auf WebServer').check() : '' ;
  formData.Microsoft365 === 'on' ? 
    form.getCheckBox('EMail bei Microsoft 365').check() : '' ;
  formData.Webdesign === 'on' ? 
    form.getCheckBox('Webdesign  Webentwicklung').check() : '' ;
  formData.Werbung === 'on' ? 
    form.getCheckBox('Werbung  Marketing').check() : '' ;
  formData.Kundenbetreuung === 'on' ? 
    form.getCheckBox('Kundenbetreuung').check() : '' ;


  form.getTextField('Auftraggeber_Name').setText(formData.name);
  form.getTextField('Auftragnehmer_Datum').setText("heute");
  
  
  // Date 
  const today = new Date();
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const mm = today.getMonth()+1 < 10 ? `0${today.getMonth()+1}` : today.getMonth()+1; 
  const yyyy = today.getFullYear();
  const date = `${dd}.${mm}.${yyyy}`;
  form.getTextField('Auftragnehmer_Datum').setText(date)

  // get PNG & sign
  const signatureUrl = '/assets/Martin_unterschrift.png'
  const signatureBytes = await fetch(signatureUrl).then(res => res.arrayBuffer())
  const signatureImage = await pdfDoc.embedPng(signatureBytes)
  form.getButton('Auftragnehmer_unterschrift').setImage(signatureImage)
  form.getButton('Auftragnehmer_unterschrift').setImage(signatureImage)

  // set fonts
  form.updateFieldAppearances(fontMedium)
  form.getTextField('Firma').defaultUpdateAppearances(fontBold)


  // add Microsoft-Kundenvertrag
  if (formData.Microsoft365 === 'on') {
    const microsoftUrl = '/assets/Microsoft-Kundenvertrag.pdf'
    const microsoftPdfBytes = await fetch(microsoftUrl).then(res => res.arrayBuffer())
    const microsoftpdfDoc = await PDFDocument.load(microsoftPdfBytes)
    
    const microsoftPages = await pdfDoc.copyPages(microsoftpdfDoc, microsoftpdfDoc.getPageIndices());
    microsoftPages.forEach((page) => pdfDoc.addPage(page));
  }
  


  // Flatten the form's fields
  form.flatten();

  // Serialize the PDFDocument to bytes (a Uint8Array)
  const pdfBytes = await pdfDoc.save()

  // Trigger the browser to download the PDF document
  download(pdfBytes, "AV Vertrag mit dem HÄUPTLING.pdf", "application/pdf");
}


